import classNames from 'classnames'
import React from 'react'
import { navigateBack } from '../../store/history/history.actions'
import { TAG_BACK } from '../analytics/analytics.tagids.constants'
import TagActionButton from '../genericComponents/TagActionButton'
import arrowLeft from '../genericComponents/assets/arrow-left.svg'
import { useAction } from '../utils/react-redux'
import s from './BackButton.less'

const BackButton = ({ hasTag, transparent, className }) => {
  const execNavigateBack = useAction(navigateBack)

  return hasTag ? (
    <TagActionButton
      type={TAG_BACK}
      className={classNames(s.backButton, transparent && s.transparent)}
      onClick={() => execNavigateBack()}
    >
      <img src={arrowLeft} className="ssrImageGrey" alt="" width={24} height={24} />
    </TagActionButton>
  ) : (
    <div className={classNames(s.backButton, transparent && s.transparent, className)} onClick={() => execNavigateBack()}>
      <img src={arrowLeft} className="ssrImageGrey" alt="" width={24} height={24} />
    </div>
  )
}

export default BackButton
